export const portfolioData = {
  personal: {
    name: "Elie BOTUNA",
    title: "UI/UX Design and Front End Developer",
    description: "Passionné par la création d'expériences utilisateur exceptionnelles et le développement web moderne.",
    email: "contact@eliebotuna.com",
    location: "Kinshasa, RDC"
  },
  skills: [
    {
      name: "HTML5",
      level: 90,
      category: "Frontend"
    },
    {
      name: "CSS3",
      level: 85,
      category: "Frontend"
    },
    {
      name: "JavaScript",
      level: 80,
      category: "Frontend"
    },
    {
      name: "React",
      level: 85,
      category: "Frontend"
    },
    {
      name: "Node.js",
      level: 75,
      category: "Backend"
    },
    {
      name: "Python",
      level: 70,
      category: "Backend"
    },
    {
      name: "UI/UX Design",
      level: 85,
      category: "Design"
    },
    {
      name: "Figma",
      level: 90,
      category: "Design"
    }
  ],
  services: [
    {
      title: "UI/UX Design",
      description: "Création d'interfaces utilisateur intuitives et d'expériences utilisateur engageantes",
      icon: "🎨"
    },
    {
      title: "Développement Front-end",
      description: "Développement d'applications web modernes avec React.js",
      icon: "💻"
    },
    {
      title: "Design Graphique",
      description: "Création de designs graphiques et retouche photo",
      icon: "✨"
    }
  ],
  experience: [
    {
      title: "UI/UX Designer Senior",
      company: "Tech Solutions",
      period: "2020 - Présent",
      description: "Création d'interfaces utilisateur pour des applications web et mobiles"
    },
    {
      title: "Développeur Front-end",
      company: "Digital Agency",
      period: "2018 - 2020",
      description: "Développement d'applications web avec React.js"
    }
  ],
  projects: [
    {
      title: "Application E-commerce",
      description: "Design et développement d'une plateforme e-commerce moderne",
      technologies: ["React", "Figma", "Node.js"]
    },
    {
      title: "Application Mobile",
      description: "Création d'une interface utilisateur pour une application mobile",
      technologies: ["UI/UX", "Figma", "React Native"]
    }
  ],
  education: [
    {
      degree: "Master en Design Numérique",
      school: "Digital Design Institute",
      period: "2016 - 2018"
    },
    {
      degree: "Licence en Informatique",
      school: "Tech University",
      period: "2012 - 2016"
    }
  ],
  socialLinks: [
    {
      name: "LinkedIn",
      url: "https://linkedin.com/in/eliebotuna",
      icon: "linkedin"
    },
    {
      name: "GitHub",
      url: "https://github.com/eliebotuna",
      icon: "github"
    },
    {
      name: "Twitter",
      url: "https://twitter.com/eliebotuna",
      icon: "twitter"
    }
  ]
}; 